<template>
  <modal title="Search Posts" ref="modal">
    <div class="q-gutter-y-md">
      <q-input v-for="kw in keywords" :key="kw" :model-value="kw" dense>
        <template v-slot:append>
          <q-btn
            icon="fa fa-trash"
            title="Remove keyword"
            flat
            round
            dense
            @click="removeKeyword(kw)"
          />
        </template>
      </q-input>
      <q-input
        v-model="keyword"
        placeholder="Add keyword..."
        dense
        autofocus
        @keyup.enter="addKeyword"
      >
        <template v-slot:append>
          <q-btn icon="fa fa-plus" flat round @click="addKeyword" />
        </template>
      </q-input>
    </div>
    <template v-slot:actions>
      <async-btn
        label="Search"
        color="primary"
        :task="task"
        :disabled="!canCreate"
        @click="create"
      />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import {
  Modal as ModalElement,
  PostSearch,
} from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { create } from '.';

interface Data {
  keyword: string,
  keywords: string[],
  task?: Promise<PostSearch>
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    Modal,
    AsyncBtn,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      keyword: '',
      keywords: [],
      task: undefined,
    };
  },
  computed: {
    canCreate(): boolean {
      return (this.keywords.length > 0);
    },
  },
  methods: {
    addKeyword() {
      if (this.keyword === '') return;
      if (this.keywords.includes(this.keyword)) return;
      this.keywords.push(this.keyword);
      this.keyword = '';
    },
    removeKeyword(keyword: string) {
      const index = this.keywords.findIndex(kw => kw === keyword);
      if (index >= 0) {
        this.keywords.splice(index, 1);
      }
    },
    create() {
      this.task = create(this.clientId, this.keywords);
      this.task.then((postSearch: PostSearch) => {
        this.$emit('ok', postSearch);
        (this.$refs.modal as ModalElement).hide();
        notify({
          message: 'Searching posts, you will receive an in-app notification when it\'s finished.',
          timeout: 60000,
          actions: [
            { label: 'Dismiss', color: 'positive' },
          ],
        });
      });
    },
  },
});
</script>
